import {
    useLocation
} from "react-router-dom";


// it check route path is exactly equal to argument, return true or false
const useCheckRoute = (path) => {
    const location = useLocation();
    const currentPathname = location.pathname;
    return currentPathname.startsWith(path);

}

export default useCheckRoute